import React from 'react';
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';

import Button from '../../components/Button';
import HeaderLogo from '../../components/HeaderLogo'

function Home() {
  return (
    <div className="page-container">
        <HeaderLogo />
        <div className="home-title">
            <div className="h1 semibold alight-left z100">#ช่างถูกงานวัสดุถูกใจ</div>
            <div className="h3 italic alight-left z100">ฉลองโปรโมชั่นปรับปรุงบ้านตลอดปี 2021</div>
            <div className="floating-kay home-kay">
                <img className="kay-container" src="/asset/kay_float.png" />
            </div>
        </div>
        <div className="home-title-card box-shadow">
            {/* <div className="cover-header-container green-bg box-shadow h3">โปรโมชั่นปูกระเบื้อง</div> */}
            <div className="h2 bold alight-left green-text">แพ็คเกจปูกระเบื้อง (พร้อมของ)</div>
            <div className="home-title-sub-line h4 bold alight-left italic">พื้นสวย - ผนังเนี๊ยบ - เรียบทุกแผ่น</div>
            <div className="h4 alight-left">เลือกได้ถึง 16 แบบ! ตอบโจทย์ทุกไลฟ์สไตล์</div>
            <div className="h5 red-text alight-left">เริ่มต้นเพียง <span className="h1 bold italic">5,400.-</span></div>
        </div>
        <div>
            <div className="h1 semibold">คุณมีกระเบื้องหรือยัง?</div>
            <div className="flex row">
                <Link to={'/tiles/withtiles/question'} className="home-card-link-wrapper">
                    <div className="home-card-wrapper">
                        <div className="home-card-container ">
                            <div className="home-card-image-wrapper">
                                <img className="fit-width-img" src="/asset/withtiles.png"/>
                            </div>
                            <div className="h3 semibold">มีกระเบื้องอยู่แล้ว</div>
                            {/* <div className="h6 semibold">เริ่มต้นเพียง <span className="h3 bold">฿5,400</span></div> */}
                            <Button 
                            fullWidth 
                            text={'เลือก'} 
                            style={{marginTop: '15px', marginBottom: '10px'}} 
                            />
                        </div>
                    </div>
                </Link>
                <Link to={'/tiles/notiles/type'} className="home-card-link-wrapper">
                    <div className="home-card-wrapper">
                        <div className="home-card-container">
                            <div className="home-card-image-wrapper">
                                <img className="fit-width-img" src="/asset/no tile 4.png"/>
                            </div>
                            <div className="h3 semibold">ยังไม่มีกระเบื้อง</div>
                            {/* <div className="h6 semibold">เริ่มต้นเพียง <span className="h3 bold">฿9,200</span></div> */}
                            <Button 
                            fullWidth 
                            text={'เลือก'} 
                            style={{marginTop: '15px', marginBottom: '10px'}} 
                            />
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    </div>
  );
}

export default Home;
